/* ==========================================================================
   sk-menu-lazy.js — Lazy DOM-materialization for mega-menu submenus.
   Submenu HTML is wrapped in <template data-submenu-lazy> tags by Liquid.
   Templates are parsed by browser but do NOT create initial DOM nodes.
   On first hover/focus/touch on a parent menu item, we clone the template
   content into the DOM. Saves ~2000 initial DOM nodes across the header.
   ========================================================================== */
(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  var activated = new WeakSet();

  function materialize(parent) {
    if (activated.has(parent)) return;
    activated.add(parent);
    // Template can live inside <details> or directly under the <li>
    var tpl = parent.querySelector('template[data-submenu-lazy]');
    if (!tpl || !tpl.content) return;
    var detailsEl = parent.querySelector(':scope > details');
    var target = detailsEl || parent;
    target.appendChild(tpl.content.cloneNode(true));
    // Remove template to free memory (content already cloned)
    tpl.remove();
    // Notify listeners (theme JS) that submenu DOM exists now
    parent.dispatchEvent(new CustomEvent('sk:submenu-ready', { bubbles: true }));
  }

  function bind() {
    var parents = document.querySelectorAll('[data-navmenu-parent]');
    parents.forEach(function (parent) {
      if (parent.dataset.skLazyBound) return;
      parent.dataset.skLazyBound = '1';
      // Activate on any user intent
      parent.addEventListener('mouseenter', function () { materialize(parent); }, { passive: true });
      parent.addEventListener('focusin', function () { materialize(parent); });
      parent.addEventListener('touchstart', function () { materialize(parent); }, { passive: true });
      // Also on click (in case hover was skipped)
      parent.addEventListener('click', function () { materialize(parent); }, { passive: true });
    });
  }

  // Prefetch closest parent on pointer approach — preemptive rendering.
  // Triggers ~50-200ms before the user actually hovers the menu item.
  function bindPrefetch() {
    var nav = document.querySelector('[data-site-navigation]');
    if (!nav) return;
    nav.addEventListener('pointerover', function (e) {
      var parent = e.target.closest('[data-navmenu-parent]');
      if (parent) materialize(parent);
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bind();
      bindPrefetch();
    });
  } else {
    bind();
    bindPrefetch();
  }
})();
